import { useShiftPositionDetails } from '../../../../ui/features/shift/hooks/useShiftPositionDetails';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
const positionProperties = [
    'occupationGroup',
    'occupations',
    'ecls',
    'skills',
    'trainings',
    'languages',
    'state',
    'counties',
    'tribes',
    'deploymentDuration',
    'deploymentTravelWillingness',
    'federalDeploymentWillingness',
    'priorCommitments',
    'trainCourses',
];
export const ShiftPositionDetails = ({ shiftId, positionId }) => {
    const { t } = useMissionsTranslation();
    const { shiftPositionDetails, isLoading } = useShiftPositionDetails({ shiftId, positionId });
    const settings = useSelector(getSettings);
    if (isLoading || !shiftPositionDetails) {
        return (React.createElement(Box, { justifyContent: 'center', display: 'flex' },
            React.createElement(CircularProgress, { "aria-label": t('common.loading') })));
    }
    return (React.createElement(TableContainer, { sx: { backgroundColor: themeColors.surface.secondary, p: 3 / 2 } },
        React.createElement(Table, { size: 'small' },
            React.createElement(TableBody, null, positionProperties
                .filter((key) => shiftPositionDetails[key])
                .map((key) => {
                var _a, _b;
                return (React.createElement(TableRow, { key: key },
                    React.createElement(TableCell, { sx: {
                            verticalAlign: 'top',
                            borderBottom: 'unset',
                            width: 160,
                            color: themeColors.text.subtle,
                            p: 1 / 2,
                        } }, t(`shifts.positionDetails.keys.${key}`, { esarVhpCode: (_b = (_a = settings.esarVhp) === null || _a === void 0 ? void 0 : _a.clientCode) !== null && _b !== void 0 ? _b : '' })),
                    React.createElement(TableCell, { sx: {
                            verticalAlign: 'top',
                            borderBottom: 'unset',
                            fontWeight: 500,
                            p: 1 / 2,
                        } },
                        shiftPositionDetails[key],
                        key === 'deploymentDuration' && ` ${t('shifts.positionDetails.days')}`)));
            })))));
};
